import i18next from 'i18next';

i18next.addResources('en', 'CHANGE_PASSWORD', {
  TITLE: 'Change Password',
  FORM_TITLE: 'Create new password',
  FORM_SUBTITLE: 'Please enter your new password below.',
  PASSWORD_LABEL: 'New Password',
  PASSWORD_PLACEHOLDER: 'Enter new password',
  CONFIRM_PASSWORD_LABEL: 'Confirm New Password',
  CONFIRM_PASSWORD_PLACEHOLDER: 'Confirm your new password',
  SUBMIT_BUTTON: 'Update password',
  SUCCESS_MESSAGE: 'Your password has been successfully updated.',
  ERROR_GENERIC: 'There was an error updating your password. Please try again.',
  ERROR_MATCH: 'Passwords do not match.',
  NEW_PWD_LABEL: 'New Password',
  CONFIRM_PWD_LABEL: 'Confirm New Password',
  SUBMIT: 'Update',
});

i18next.addResources('es', 'CHANGE_PASSWORD', {
  TITLE: 'Cambiar contraseña',
  FORM_TITLE: 'Crear nueva contraseña',
  FORM_SUBTITLE: 'Por favor, ingresá tu nueva contraseña a continuación.',
  PASSWORD_LABEL: 'Nueva contraseña',
  PASSWORD_PLACEHOLDER: 'Ingresá la nueva contraseña',
  CONFIRM_PASSWORD_LABEL: 'Confirmar nueva contraseña',
  CONFIRM_PASSWORD_PLACEHOLDER: 'Confirmá tu nueva contraseña',
  SUBMIT_BUTTON: 'Actualizar contraseña',
  SUCCESS_MESSAGE: 'Tu contraseña ha sido actualizada con éxito.',
  ERROR_GENERIC: 'Hubo un error al actualizar tu contraseña. Por favor, intentá de nuevo.',
  ERROR_MATCH: 'Las contraseñas no coinciden.',
  NEW_PWD_LABEL: 'Nueva contraseña',
  CONFIRM_PWD_LABEL: 'Confirmar nueva contraseña',
  SUBMIT: 'Actualizar',
});
